import styled from 'styled-components';

export const ButtonsWrapper = styled.div`
  display: inline-flex;
  gap: 4px;
  padding: 8px 16px;
  background-color: ${props => props.theme.uiColors.multiFlightMapBackgroundColor};
  border-radius: 8px;
`;
